import {useLegacyGrpcRequestCallback} from '@aboutyou/data-fetcher';
import {CheckoutV1_HasValidSession} from '@aboutyou/grpc-clients/grips/protos/checkout/checkout_v1.grpc';
import {useUser, useSimpleUserTokenOrSessionId} from '@aboutyou/user';
import {useCallback} from 'react';

export class InsufficientUserDataError extends Error {}

/**
 *
 * @returns
 * @deprecated use `useIsAuthenticated({includeCheckoutSession:true})` instead
 */
export const useIsCheckoutSessionValid = () => {
  const user = useUser();
  const tokenOrSessionId = useSimpleUserTokenOrSessionId();
  const hasValidCheckoutSession = useLegacyGrpcRequestCallback(
    CheckoutV1_HasValidSession,
  );

  let authToken = '';
  if (tokenOrSessionId && 'token' in tokenOrSessionId) {
    authToken = tokenOrSessionId.token;
  }

  const checkoutSessionSecret = user.data?.checkoutSession?.secret;
  const checkoutSessionCookieValue = user.data?.checkoutSession?.cookieValue;

  return useCallback(() => {
    if (!checkoutSessionSecret || !checkoutSessionCookieValue || !authToken) {
      throw new InsufficientUserDataError();
    }

    return hasValidCheckoutSession.mutateAsync({
      session: {
        authToken,
      },
      checkoutSession: {
        secret: checkoutSessionSecret,
        cookieValue: checkoutSessionCookieValue,
      },
    });
  }, [
    authToken,
    checkoutSessionCookieValue,
    checkoutSessionSecret,
    hasValidCheckoutSession,
  ]);
};
